import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Picture from '../../../Picture/Picture.jsx';

import './LoadingFreelance.scss';

export default class LoadingFreelance extends Component {
  render() {
    return (
      <div className={this.props.className}>
        <Helmet>
          <title>Chargement du consultant</title>
        </Helmet>
        <div className="row row-freelance-loading">
          <div className="col-sm-2 col-md-4">
            <Picture
              src={null}
              alt="consultant"
              className="picture" />
          </div>
          <div className="col-sm-10 col-md-8">
            <div className="d-flex flex-wrap align-items-end">
              <p className="name animated-empty-background" />
            </div>
            <div className="d-flex flex-wrap align-items-center">
              <p className="title animated-empty-background" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}